import * as ng from 'angular';

export default (module: ng.IModule) => {
    module.service('CopyPasteFilesService', CopyPasteFilesService);
};

interface LegacyFile {
    name: string;
    size: number;
    type: string;
    base: string | ArrayBuffer | null;
    file: File;
}

export class CopyPasteFilesService {
    static $inject = [];

    constructor() {}

    filesFromAngularEvent($event: BaseJQueryEventObject) {
        return this.filesFromEvent($event.originalEvent as ClipboardEvent);
    }

    filesFromEvent(event: ClipboardEvent): File[] {
        const clipboardItems = Array.from(event.clipboardData?.items ?? []);
        return clipboardItems.map((item) => item.getAsFile()).filter(Boolean) as File[];
    }

    toLegacyFile(file: File): Promise<LegacyFile> {
        const mapToLegacyFormat = (file: File, base64: any) => ({
            file,
            name: file.name,
            size: file.size,
            type: file.type,
            base: base64,
        });

        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onloadend = () => {
                resolve(mapToLegacyFormat(file, reader.result));
            };

            reader.onerror = (e) => reject(e);

            reader.readAsDataURL(file);
        });
    }
}
